import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { DownArrowIcon } from "../icons/DownArrowIcon";
import { useSelector } from "react-redux";

function GoToSubtaskButton({
    parentRef
}) {
    const TARGET_ID = "subtaskSection";
    const SCROLL_CONTAINER_ID = "contentContainer";
    const { lists } = useSelector(state => state.list)
    const [targetVisible, setTargetVisible] = useState(false);  
    const [position, setPosition] = useState({ left: 0 });

    useEffect(() => {
        const handleScroll = () => {
            const target = document.getElementById(TARGET_ID);
            const scrollContainer = document.getElementById(SCROLL_CONTAINER_ID);

            if (target && scrollContainer) {
                const targetRect = target.getBoundingClientRect();
                const containerRect = scrollContainer.getBoundingClientRect();

                // Check if the target is within the visible bounds of the scroll container
                if (targetRect.top <= containerRect.bottom) {
                    setTargetVisible(true);
                } else {
                    setTargetVisible(false);
                }
            }
        };

        const scrollContainer = document.getElementById(SCROLL_CONTAINER_ID);
        if (scrollContainer) {
            scrollContainer.addEventListener('scroll', handleScroll);
        }

        // Initial check
        handleScroll();

        return () => {
            if (scrollContainer) {
                scrollContainer.removeEventListener('scroll', handleScroll);
            }      
        },[];
    });
    useEffect(() => {
        const updatePosition = () => {
            if (parentRef) {
                const rect = parentRef.getBoundingClientRect();
                const left = rect.left + rect.width / 2 + 'px';
                setPosition({ left });
            }
        };

        updatePosition(); // Initial position
        window.addEventListener('resize', updatePosition);

        // Create ResizeObserver to watch parentRef size changes
        const resizeObserver = new ResizeObserver(updatePosition);
        if (parentRef) {
            resizeObserver.observe(parentRef);
        }

        return () => {
            window.removeEventListener('resize', updatePosition);
            resizeObserver.disconnect();
        };
    }, [parentRef]);


    const handleClick = () => {
        const target = document.getElementById(TARGET_ID);
        const scrollContainer = document.getElementById(SCROLL_CONTAINER_ID);

        if (target && scrollContainer) {
            const targetPosition = target.getBoundingClientRect().top + scrollContainer.scrollTop;
            scrollContainer.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    }

    if (targetVisible) return null;
    if (!lists || lists.length === 0) return null;
    
    return (
        <Button 
            className="btn-cyan btn-sm see-subtasks-btn box-shadow-sm rounded-pill" 
            onClick={handleClick}
            style={position?.left === '0px' ? {} : position}
        >
            <DownArrowIcon color="white" height="12" width="11" className="me-1" />
            See List
        </Button>
    );
}

export { GoToSubtaskButton };